import { Routes, Route, Navigate } from 'react-router-dom';
import { useKeycloak } from '@/contexts/KeycloakContext';
import { Home } from '@/pages/Home';
import { Subscriptions } from '@/pages/Subscriptions';
import { Barriers } from '@/pages/Barriers';
import { SafetyPlan } from '@/pages/SafetyPlan';
import { Contexts } from '@/pages/Contexts';
import { Settings } from '@/pages/Settings';
import { Onboarding } from '@/pages/Onboarding';
import { Login } from '@/pages/Login';
import { Connect } from '@/pages/Connect';
import { Connected } from '@/pages/Connected';
import { Layout } from '@/components/Layout';
import { LoadingScreen } from '@/components/LoadingScreen';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { authenticated, initialized } = useKeycloak();

  if (!initialized) {
    return <LoadingScreen />;
  }

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

export function App() {
  const { initialized } = useKeycloak();

  if (!initialized) {
    return <LoadingScreen />;
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/connect/:token" element={<Connect />} />
      <Route path="/connected" element={<Connected />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Home />} />
        <Route path="email" element={<Subscriptions />} />
        <Route path="barriers" element={<Barriers />} />
        <Route path="support" element={<SafetyPlan />} />
        <Route path="contexts" element={<Contexts />} />
        <Route path="settings" element={<Settings />} />
        <Route path="onboarding" element={<Onboarding />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
